module.exports = __webpack_public_path__ + "img/schlosserei-raichle-logo.e623a857.svg";